module.exports = __webpack_public_path__ + "static/media/notifBell.b6453ec5.svg";